import { gql } from 'apollo-angular';
import { DISCOUNT_GROUP_BASE_RELATION_FRAGMENT } from "./discount-group.definition";
import { PRODUCT_GROUP_FIELDS_FRAGMENT } from "./product-group.definition";
import { DELETION_RESPONSE_FRAGMENT } from './system-definition';

export const DISCOUNT_GROUP_PRODUCT_GROUP_RELATION_FRAGMENT = gql`
fragment DiscountGroupProductGroupRelation on DiscountGroupProductGroupRelation {
    ...DiscountGroupRelationBase
    productGroupId
    productGroup {
        ...ProductGroupFields
    }
}
${DISCOUNT_GROUP_BASE_RELATION_FRAGMENT}
${PRODUCT_GROUP_FIELDS_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATIONS = gql`
query GetDiscountGroupProductGroupRelations($input:DiscountGroupProductGroupRelationSearchInput) {
    getDiscountGroupProductGroupRelations(input: $input) {
        totalItems
        items {
            ...DiscountGroupProductGroupRelation
        }
    }
}
${DISCOUNT_GROUP_PRODUCT_GROUP_RELATION_FRAGMENT}
`;

export const GET_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION = gql`
query GetDiscountGroupProductGroupRelation($id:String!) {
    getDiscountGroupProductGroupRelation(id: $id) {
        ...DiscountGroupProductGroupRelation
    }
}
${DISCOUNT_GROUP_PRODUCT_GROUP_RELATION_FRAGMENT}
`;


export const SAVE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION = gql`
mutation SaveDiscountGroupProductGroupRelation($input: DiscountGroupProductGroupRelationInput!) {
    saveDiscountGroupProductGroupRelation(input: $input) {
        ... DiscountGroupProductGroupRelation
    }
}
${DISCOUNT_GROUP_PRODUCT_GROUP_RELATION_FRAGMENT}
`;

export const DELETE_DISCOUNT_GROUP_PRODUCT_GROUP_RELATION = gql`
mutation DeleteDiscountGroupProductGroupRelation($id: String!) {
    deleteDiscountGroupProductGroupRelation(id: $id) {
        ... DeletionResponse
    }
}
${DELETION_RESPONSE_FRAGMENT}
`;